// src/features/dashboard/mockData/Employee/overviewCard.mock.ts

import type {
  OverviewCardResponse,
} from '../../types/Employee/overviewCard.types';

export const overviewCardMock:
  OverviewCardResponse = {

  items: [],
};